import * as signalR from '@microsoft/signalr';
import store from '@/store/store';
import apiConfig from '@/api/apiConfig';
import {
	ModuleNotification,
	ModuleInvoice,
	ModuleInbox,
	ModuleOrganization,
	ModuleAudditingLog,
	ModuleLicenseInfo,
	ModuleNotificationUser,
	ModuleUser,
	ModuleLayout,
	ModuleColumnExport,
	ModuleAnalysisReport
} from '../store/module-const';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import PopupUtils from '../common/PopupUtils';
import commonFunc from '../common/commonFunction';
import { MSEnum } from '@/common/enumeration';
import { ungzip } from 'pako';

const ADD_INVOICE = 'NewInvoice';
const ADD_EMAIL = 'NewEmail';
const InvoiceNotFound = 'InvoiceNotFound';
const UPDATE_NOTIFICATION = 'Notification';
const EXPIRED = 'Expired';
const FileHasProcessed = 'FileHasProcessed';
const FileHasProcessedDeclaration = 'FileHasProcessedDeclaration';
const FileFailedProcessed = 'FileFailedProcessed';
const FileFailedProcessedDeclaration = 'FileFailedProcessedDeclaration';
const InvoiceChecked = 'InvoiceChecked';
const OutInvoiceChecked = 'OutInvoiceChecked';
const NotifyProcessCheckSupplier = 'NotifyProcessCheckSupplier';
const NotifySync = 'Sync';
const NotifySyncTaxaxion = 'SyncTaxaxion';
const NotifyDownloadAgain = 'DownloadAgain';
const LoadAgainPdfFromEmail = 'LoadAgainPdfFromEmail';
const DownAgainPdfSuccess = 'DownAgainPdfSuccess';
const DownAgainPdfFail = 'DownAgainPdfFail';
const AutoDownload = 'AutoDownload';
const ConnectInvoiceMaster = 'ConnectInvoiceMaster';
const ConnectInvoiceDetail = 'ConnectInvoiceDetail';
const SyncAgainInvoiceDetail = 'SyncAgainInvoiceDetail';
const SyncAgainOutInvoiceDetail = 'SyncAgainOutInvoiceDetail';
const MatchNumberInv = 'MatchNumberInv';
const NotMatchNumberInv = 'NotMatchNumberInv';
const ErrorCompareInv = 'ErrorCompareInv';
const ConnectOutInvoiceMaster = 'ConnectOutInvoiceMaster';
const ConnectOutInvoiceDetail = 'ConnectOutInvoiceDetail';
const LoginTax = 'LoginTax';
const GetInvoicesTax = 'GetInvoicesTax';
const ProcessingInvoiceTax = 'ProcessingInvoiceTax';
const EndProcessingInvoiceTax = 'EndProcessingInvoiceTax';
const DownloadLargeNumberInvoice = 'DownloadLargeNumberInvoice';
const HaveNewDataDashBoard = 'HaveNewDataDashBoard';
const ChangeAppGroup = 'ChangeAppGroup';
const CheckedDeclaration = 'CheckedDeclaration';
const ImportComplete = 'ImportComplete';
const SyncInvoiceDetail = 'SyncInvoiceDetailFromTax';
const SyncInvoiceDetailOut = 'SyncInvoiceDetailOutFromTax';
const AVAExplainInvoice = 'AVAExplainInvoice';
const SearchInvoiceInfo = 'SearchInvoiceInfo';
const LoginInfo = 'LoginInfo';
const MoveInvoiceInfo = 'MoveInvoiceInfo';
const MoveDeclarationInfo = 'MoveDeclarationInfo';
const InvoiceWaitingNotification = 'InvoiceWaitingNotification';
const TaxaxionSyncNotification = 'TaxaxionSyncNotification';
const TotalInvoiceRiskSupplier = 'TotalInvoiceRiskSupplier';
const MultiCheckingResultFlags = 'MultiCheckingResultFlags';
const AnalysisAIResult = 'AnalysisAIResult';
const ConvertIdentificationNumber = 'ConvertIdentificationNumber';

class PushHandler {
	PushHandler() {
		this.isConnected = false;
		this.connection = null;
	}
	/**
	 * Khởi tạo kết nối và gắn các sự kiện xử lý
	 */
	init() {
		const me = this;
		//Kiểm tra link SignalR
		if (!apiConfig['SignalR']) {
			console.log('Không tìm thấy url của SignalR', store.state.auth);
			return;
		}

		//Khởi tạo option kết nối
		let options = {
			accessTokenFactory: () => commonFunc.getJWTToken()
		};
		//Cấu hình Transport cho Hub
		let hubTransport = window.__env.externalServiceConfig.HubTransport;
		if (hubTransport == 'WebSockets') {
			Object.assign(options, {
				transport: signalR.HttpTransportType.WebSockets,
				skipNegotiation: true
			});
		} else if (hubTransport == 'ServerSentEvents') {
			Object.assign(options, {
				transport: signalR.HttpTransportType.ServerSentEvents
			});
		} else if (hubTransport == 'LongPolling') {
			Object.assign(options, {
				transport: signalR.HttpTransportType.LongPolling
			});
		}
		//Khởi tạo connection
		me.connection = new signalR.HubConnectionBuilder()
			.withUrl(apiConfig['SignalR'] + '/hubs/notification', options)
			.configureLogging(signalR.LogLevel.Information)
			.build();

		//Lắng nghe sự kiện tin nhắn đến
		me.connection.on('OnMessage', data => {
			console.log('SignalR:OnMessage::', data);
			if (!data) return;
			me.handleEventMessage(data, store);
		});

		//Đang kết nối lại tới máy chủ SignalR
		me.connection.onreconnecting(ex => {
			console.log('Kết nối lại bị lỗi tới máy chủ SignalR');
		});

		//Kết nối lại thành công tới máy chủ SignalR
		me.connection.onreconnected(connectionId => {
			me.isConnected = true;
			console.log('Kết nối lại thành công tới máy chủ SignalR, url:: ' + apiConfig['SignalR']);
		});

		//Kết nối bị đóng tới máy chủ SignalR
		me.connection.onclose(ex => {
			me.isConnected = false;
			console.log('Bị ngắt kết nối tới SignalR:: ', ex);
			//Kết nối lại sau một khoảng thời gian tới máy chủa SignalR
			me.reConnection(store);
		});

		//Kết nối tới máy chủ SignalR
		me.startConnection(store);
	}

	/**
	 * Khởi tạo kết nối tới misa web socket
	 */
	async initMWS() {
		const me = this;
		//Gọi api lấy token MWS
		let user = store.getters['user/User'];
		//Thêm SubscriberId vì nếu không có thì call api lên cũng văng lỗi
		if (!user || !user.SubscriberId) return;

		let tokenMWS; // Đối tượng token MWS
		let cacheTokenMWS = store.getters['user/MWSToken'];
		if (!cacheTokenMWS || !cacheTokenMWS.Token || me.checkExpiredDateTokenMWS(cacheTokenMWS.ExpiredDate)) {
			tokenMWS = await me.getTokenMWS(user);
		} else {
			tokenMWS = cacheTokenMWS.Token;
		}
		if (!tokenMWS) return;

		//console.log(`cacheTokenMWS_TraceTool::tokenMWS::${tokenMWS}`);
		//Khởi tạo option kết nối
		let paramConect = {
			socketURL: tokenMWS.BrokerUrl,
			socketOption: {},
			token: tokenMWS.Token
		};
		let optionMWS = {
			...paramConect,
			onTokenInvalid: async function(e) {
				// Gọi lại lấy token mới
				tokenMWS = await me.getTokenMWS(user);
			},
			onConnectError: function(e) {
				console.log('connect mws error', paramConect);
				MWSClient.init(paramConect);
			},
			onDisconnect: function(reason) {
				console.log('disconnect mws', paramConect);
				MWSClient.init(paramConect);
			}
		};

		//console.log(`cacheTokenMWS_TraceTool::optionMWS::${optionMWS}`);
		MWSClient.logEnable = window.__env.misaWebSocket.logEnable;
		//Khởi tạo connection
		MWSClient.init(optionMWS);
		//Hàm khởi tạo sự kiện
		MWSClient.on(window.__env.misaWebSocket.OnMessage, (event, listener) => {
			if (!event) return;
			const me = this;
			me.handleEventMessage(JSON.parse(event), store);
		});
	}

	/**
	 * Hàm gọi lấy token MWS
	 * @param {*} user
	 * @returns
	 */
	async getTokenMWS(user) {
		const me = this;
		//Lấy token của MWS
		let payload = {
			Email: user.Email,
			Id: user.Id,
			SubscriberId: user.SubscriberId,
			FullName: user.FullName
		};
		let tokenMWS = await store.dispatch(`${ModuleUser}/getTokenFromMWS`, payload);
		if (!tokenMWS || !tokenMWS.TokenExpiredSecond) return;

		//Thời gian cache nhỏ hơn thời gian hết hạn token 15%
		let maxAge = tokenMWS.TokenExpiredSecond - tokenMWS.TokenExpiredSecond * 0.15;
		//Cache lại token
		store.commit(`${ModuleUser}/updateMWSToken`, {
			ExpiredDate: new Date().getTime() + maxAge,
			Token: tokenMWS
		});
		return tokenMWS;
	}

	/**
	 * Hàm check cache ở client đã hết hạn hay chưa
	 * @param {*} expiredDate
	 * @returns
	 */
	checkExpiredDateTokenMWS(expiredDate) {
		if (!expiredDate) return true;
		let currentDate = new Date().getTime();
		if (currentDate > expiredDate) {
			return true;
		}
		return false;
	}

	/**
	 * Xử lý message từ SignalR/MWS
	 * @param {Object} data - Dữ liệu nhận được từ SignalR/MWS
	 * @param {Object} store - Vuex store
	 * @author hvanh - 1.3.2024 (original)
	 * @author ttanh - 9.9.2025 (optimized)
	 */
	handleEventMessage(data, store) {
		const me = this;
		if (!data) return;

		// Tạo đối tượng notification từ dữ liệu nhận được
		const notificationMess = me._buildNotification(data);
		const orgIdWorking = commonFunc.getOrgParamOrgOnly();
		const user = store.getters['user/User'];

		// Xử lý các loại thông báo đặc biệt - kiểm tra ngay từ đầu và thoát sớm nếu thỏa mãn
		if (me._handleSpecialNotificationTypes(data, notificationMess, store, user)) {
			return;
		}

		// Kiểm tra nếu không phải đơn vị đang làm việc thì bỏ qua
		if (orgIdWorking !== notificationMess.OrgId && orgIdWorking !== notificationMess.OrganizationIdWorking) {
			return;
		}

		// Cập nhật danh sách tải hóa đơn nếu có TransId
		if (data.Content && data.Content.TransId) {
			EventBusGlobal.$emit(GlobalEventName.NewInvoice, data);
		}

		// Xử lý theo từng loại thông báo
		me._processNotificationByType(data, notificationMess, store, orgIdWorking, user);

		// Xử lý thông báo từ email
		me._processEmailNotification(data, notificationMess, store);
	}

	/**
	 * Tạo đối tượng thông báo từ dữ liệu nhận được
	 * @param {Object} data - Dữ liệu từ server
	 * @returns {Object} Đối tượng thông báo đã được xử lý
	 * @private
	 */
	_buildNotification(data) {
		const me = this;

		// Kiểm tra có dữ liệu bị nên theo Content không
		if (data.ContentCompress && !data.Content) {
			const contentUnzip = me.unzipDataCompress(data.ContentCompress);
			if (contentUnzip) {
				data.Content = JSON.parse(contentUnzip);
			}
		}

		// Kiếm tra dữ liệu có bị nén theo FileProcessedStatus không
		// Sau sẽ xóa đoạn này đi
		if (data.Content && data.Type == FileHasProcessed) {
			if (data.Content.FileProcessedStatusCompress && !data.Content.FileProcessedStatus) {
				const dataUnzip = me.unzipDataCompress(data.Content.FileProcessedStatusCompress);
				if (dataUnzip) {
					data.Content.FileProcessedStatus = JSON.parse(dataUnzip);
				}
			}
		}

		// Khởi tạo đối tượng thông báo cơ bản
		const notification = {
			Content: data.Title,
			Type: data.Type,
			ReceivedDate: new Date(),
			OrgId: data.OrgId || (data.Content ? data.Content.OriganizationId : null),
			Status: data.Status,
			Invoices:
				data.Content && data.Content.FileProcessedStatus ? data.Content.FileProcessedStatus.Candidates : null,
			TransId: data.Content ? data.Content.TransId : null,
			EmailId: data.Content && data.Content.EmailStatus ? data.Content.EmailStatus.EmailId : null,
			ActionType: data.Content ? data.Content.ActionType : null,
			IsConnectTaxaxion: data.IsConnectTaxaxion,
			IsOutbot: data.IsOutbot,
			CreatedDate: new Date(),
			Icon: me.getIconNotification(data),
			Title: data.Title,
			TitleEnglish: data.TitleEnglish,
			PrintPdfInfo: data.Content && data.Content.PrintPdfInfo ? data.Content.PrintPdfInfo : null,
			ExportFileInfo: data.Content && data.Content.ExportFileInfo ? data.Content.ExportFileInfo : null,
			ExtraInfor: data.Content && data.Content.ExtraInfor ? data.Content.ExtraInfor : null,
			TraceDates: data.Content && data.Content.TraceDates ? data.Content.TraceDates : null,
			Viewed: false,
			TypeReceive: me.getTypeReceive(data.Content ? data.Content.ExtraInfor : null)
		};

		// Thêm dữ liệu từ ExtraInfor vào notification
		return me.addDataExtraInforToNotification(notification);
	}

	/**
	 * Giải nén dữ liệu đã được nén bằng gzip và encode base64
	 * @param {string} base64data - Dữ liệu base64 đã được nén
	 * @returns {string} - Chuỗi gốc sau khi giải nén
	 */
	unzipDataCompress(base64data) {
		try {
			let binaryString = atob(base64data);
			let byteArray = Uint8Array.from(binaryString, c => c.charCodeAt(0));
			return ungzip(byteArray, { to: 'string' });
		} catch (error) {
			return null;
		}
	}

	/**
	 * Xử lý các loại thông báo đặc biệt
	 * @param {Object} data - Dữ liệu từ server
	 * @param {Object} notificationMess - Đối tượng thông báo
	 * @param {Object} store - Vuex store
	 * @returns {boolean} True nếu đã xử lý xong và nên dừng xử lý tiếp
	 * @private
	 */
	_handleSpecialNotificationTypes(data, notificationMess, store, user) {
		const { Type, Content } = data;
		// Thay đổi nhóm ứng dụng - yêu cầu reload
		if (Type == ChangeAppGroup) {
			store.commit(`${ModuleLayout}/clearLayoutInfo`);
			store.commit(`${ModuleColumnExport}/clearColumnExport`);
			commonFunc.showReloadPage();
			return true;
		}

		// Kiểm tra xong một tờ khai hải quan
		if (Type == CheckedDeclaration) {
			store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
			EventBusGlobal.$emit(GlobalEventName.RefreshDeclaration, { shimmerLoaded: true });
			return true;
		}

		// Giải thích kết quả kiểm tra
		if (Type == AVAExplainInvoice) {
			EventBusGlobal.$emit(GlobalEventName.AVAExplainInvoice, notificationMess);
			return true;
		}

		// Thông tin đăng nhập
		if (Type == LoginInfo) {
			EventBusGlobal.$emit(GlobalEventName.LoginInfo, notificationMess);
			return true;
		}

		// Điều chuyển hóa đơn
		if (Type == MoveInvoiceInfo) {
			this._processMoveInvoiceNotification(notificationMess, user);
			return true;
		}

		// Điều chuyển tờ khai hải quan
		if (Type == MoveDeclarationInfo) {
			this._processMoveDeclarationNotification(notificationMess);
			return true;
		}

		// Thông báo import hoàn tất
		if (Type == ImportComplete) {
			if (Content && Content.ExtraInfor) {
				let extraInforObj = JSON.parse(Content.ExtraInfor);
				if (extraInforObj && extraInforObj.ImportType && extraInforObj.ImportType.toLowerCase() == 'supplier') {
					EventBusGlobal.$emit(GlobalEventName.RefreshSupplier);
				}
			}
			return true;
		}

		// Cập nhật CCCD
		if (Type == ConvertIdentificationNumber) {
			EventBusGlobal.$emit(GlobalEventName.ConvertIdentificationNumber, notificationMess);
			return true;
		}

		return false;
	}

	/**
	 * Xử lý thông báo điều chuyển hóa đơn
	 * @param {Object} notificationMess - Đối tượng thông báo
	 * @private
	 */
	_processMoveInvoiceNotification(notificationMess, user) {
		const me = this;
		// Parse thông tin extraInfor để lấy cờ
		let extraInforObj = {};
		if (notificationMess.ExtraInfor) {
			extraInforObj = JSON.parse(notificationMess.ExtraInfor);
		}

		if (extraInforObj.UserId != user.Id) return;

		if (extraInforObj && extraInforObj.IsDuplicate === true) {
			// Kiểm tra cờ để quyết định hiển thị popup hay thêm vào quả chuông
			// Trường hợp trùng hóa đơn từ queue -> hiển thị popup cảnh báo
			me.showMoveInvoiceDuplicatePopup(notificationMess, extraInforObj);
		} else {
			// Các trường hợp khác (thành công, lỗi validation khác) -> thêm vào quả chuông
			store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
		}

		// Reload danh sách hóa đơn
		EventBusGlobal.$emit(GlobalEventName.RefreshInvoicesFirstPage, {
			shimmerLoaded: true,
			isGetTotal: true,
			isDelay: true
		});
	}

	/**
	 * Xử lý thông báo điều chuyển tờ khai hải quan
	 * @param {Object} notificationMess - Đối tượng thông báo
	 * @private
	 */
	_processMoveDeclarationNotification(notificationMess) {
		const me = this;

		// Parse thông tin extraInfor để lấy cờ
		let extraInforObj = {};
		if (notificationMess.ExtraInfor) {
			try {
				extraInforObj = JSON.parse(notificationMess.ExtraInfor);
			} catch (e) {
				extraInforObj = {};
			}
		}

		// Kiểm tra cờ để quyết định hiển thị popup hay thêm vào quả chuông
		if (extraInforObj && extraInforObj.IsDuplicate === true) {
			// Trường hợp trùng tờ khai từ queue -> hiển thị popup cảnh báo
			me.showMoveDeclarationDuplicatePopup(notificationMess, extraInforObj);
		} else {
			// Các trường hợp khác (thành công, lỗi validation khác) -> thêm vào quả chuông
			store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
		}

		// Reload danh sách tờ khai hải quan
		EventBusGlobal.$emit(GlobalEventName.RefreshDeclaration, {
			shimmerLoaded: true,
			isGetTotal: true,
			isDelay: true
		});
	}

	/**
	 * Xử lý thông báo theo từng loại
	 * @param {Object} data - Dữ liệu từ server
	 * @param {Object} notificationMess - Đối tượng thông báo
	 * @param {Object} store - Vuex store
	 * @param {string} orgIdWorking - ID của đơn vị đang làm việc
	 * @param {Object} user - Thông tin người dùng hiện tại
	 * @private
	 */
	_processNotificationByType(data, notificationMess, store, orgIdWorking, user) {
		const me = this;
		const { Type, Content } = data;

		switch (Type) {
			// Nhóm 1: Các thông báo kết nối và tải dữ liệu
			case SyncAgainInvoiceDetail:
				store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
				EventBusGlobal.$emit(GlobalEventName.RefreshInvoicesFirstPage, { shimmerLoaded: true });
				break;
			case SyncAgainOutInvoiceDetail:
				store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
				EventBusGlobal.$emit(GlobalEventName.RefreshOutInvoice, { shimmerLoaded: true }, true);
				break;
			case MatchNumberInv:
			case NotMatchNumberInv:
			case ErrorCompareInv:
			case ConnectInvoiceDetail:
			case ConnectOutInvoiceDetail:
			case DownloadLargeNumberInvoice:
				store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
				break;

			// Nhóm 2: Thông báo về nhà cung cấp
			case UPDATE_NOTIFICATION:
				EventBusGlobal.$emit(GlobalEventName.RefreshSupplier);
				commonFunc.toast({
					type: 'success',
					text: `${me.$t('i18nSupplier.CheckOneSupplierCompleted')}`,
					position: 'top-center'
				});
				break;
			// Nhóm 3: Các loại thông báo đồng bộ
			case NotifySync:
			case NotifySyncTaxaxion:
			case NotifyDownloadAgain:
				store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
				break;

			// Tải lại PDF từ email
			case LoadAgainPdfFromEmail:
				me._handleLoadAgainPdfFromEmail(data, notificationMess);
				break;

			// Đồng bộ chi tiết hóa đơn
			case SyncInvoiceDetail:
				me._handleSyncInvoiceDetail(notificationMess, store);
				break;

			// Đồng bộ chi tiết hóa đơn
			case SyncInvoiceDetailOut:
				me._handleSyncInvoiceDetailOut(notificationMess, store);
				break;

			// Có dữ liệu mới trên dashboard
			case HaveNewDataDashBoard:
				EventBusGlobal.$emit(GlobalEventName.HaveNewDataDashBoard, notificationMess.ExtraInfor);
				break;

			// Xử lý các loại thông báo về hóa đơn mới
			case FileHasProcessed:
			case FileHasProcessedDeclaration:
			case ADD_INVOICE:
			case InvoiceChecked:
				me._handleNewInvoiceNotifications(data, notificationMess, store, orgIdWorking, user);
				break;

			// Thông tin tra cứu hóa đơn
			case SearchInvoiceInfo:
				EventBusGlobal.$emit(GlobalEventName.SearchInvoiceResult, notificationMess);
				break;

			// Nhóm 4: Thông báo đã được tối ưu hóa API
			case TaxaxionSyncNotification:
				EventBusGlobal.$emit(GlobalEventName.ShowNotificationTaxaxion, notificationMess.extraInforObj);
				break;

			case InvoiceWaitingNotification:
				EventBusGlobal.$emit(GlobalEventName.ShowNotificationInvoiceWaiting, notificationMess.extraInforObj);
				break;

			case TotalInvoiceRiskSupplier:
				EventBusGlobal.$emit(GlobalEventName.ShowInvoiceRiskBySupplier, notificationMess.extraInforObj);
				break;

			case MultiCheckingResultFlags:
				EventBusGlobal.$emit(GlobalEventName.RefreshInvoiceAfterAccept);
				break;
			case AnalysisAIResult:
				me._handleAnalysisAIData(data, notificationMess, store);
				break;
			case OutInvoiceChecked:
				if (Content && !me.checkAutoDownload(Content.ExtraInfor)) {
					store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
					EventBusGlobal.$emit(GlobalEventName.RefreshOutInvoicesFirstPage);
				}
				break;
			default:
				if (Type) {
					//console.log(`Thông báo không được xử lý: ${Type}`);
				} else {
					//console.error('handleEventMessage: Loại thông báo không xác định');
				}
				break;
		}

		// Xử lý thêm thông báo vào quả chuông trong các trường hợp đặc biệt
		me._addSpecialNotificationsToBell(data, notificationMess, store);
	}

	/**
	 * Xử lý thông báo tải lại PDF từ email
	 * @param {Object} data - Dữ liệu từ server
	 * @param {Object} notificationMess - Đối tượng thông báo
	 * @private
	 */
	_handleAnalysisAIData(data, notificationMess, store) {
		const me = this;
		const analysisAIResponse = JSON.parse(data.Content.ExtraInfor);
		if (analysisAIResponse) {
			// Kiểm tra xem có dữ liệu phân tích hay không
			notificationMess.AnalysisAIResponse = analysisAIResponse;
			if (analysisAIResponse.SummaryData) {
				// const payload = {
				// 	Quarter: analysisAIResponse.SummaryData.CurrentQuarter,
				// 	Year: analysisAIResponse.SummaryData.CurrentYear
				// };
				store.commit(`${ModuleAnalysisReport}/updateAnalysisReportData`, {});
			}
		}
		notificationMess.Title = data.Title;
		notificationMess.TitleEnglish = data.TitleEnglish;
		notificationMess.Icon = 'mi-ava-analysis';
		store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);

		// Emit event để unlock nút phân tích
		EventBusGlobal.$emit(GlobalEventName.AnalysisAIResultReceived, analysisAIResponse);
	}

	/**
	 * Xử lý thông báo tải lại PDF từ email
	 * @param {Object} data - Dữ liệu từ server
	 * @param {Object} notificationMess - Đối tượng thông báo
	 * @private
	 */
	_handleLoadAgainPdfFromEmail(data, notificationMess) {
		const param = {
			EmailId: notificationMess.EmailId,
			Status: data.Content.EmailStatus.Status,
			Invoices: data.Content.InvoiceStatus,
			IsHasPdf: notificationMess.Status == DownAgainPdfSuccess
		};
		EventBusGlobal.$emit(GlobalEventName.LoadAgainPdfFromEmail, param);
	}

	/**
	 * Xử lý thông báo đồng bộ chi tiết hóa đơn
	 * @param {Object} notificationMess - Đối tượng thông báo
	 * @param {Object} store - Vuex store
	 * @private
	 */
	_handleSyncInvoiceDetail(notificationMess, store) {
		store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
		const payload = notificationMess.ExtraInfor ? JSON.parse(notificationMess.ExtraInfor) : null;
		EventBusGlobal.$emit(GlobalEventName.SyncInvoiceDetail, {
			...payload,
			Status: notificationMess.Status
		});
	}

	/**
	 * Xử lý thông báo đồng bộ chi tiết hóa đơn
	 * @param {Object} notificationMess - Đối tượng thông báo
	 * @param {Object} store - Vuex store
	 * @private
	 */
	_handleSyncInvoiceDetailOut(notificationMess, store) {
		store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
		const payload = notificationMess.ExtraInfor ? JSON.parse(notificationMess.ExtraInfor) : null;
		EventBusGlobal.$emit(GlobalEventName.SyncInvoiceDetailOut, {
			...payload,
			Status: notificationMess.Status
		});
	}

	/**
	 * Xử lý các thông báo về hóa đơn mới
	 * @param {Object} data - Dữ liệu từ server
	 * @param {Object} notificationMess - Đối tượng thông báo
	 * @param {Object} store - Vuex store
	 * @param {string} orgIdWorking - ID của đơn vị đang làm việc
	 * @param {Object} user - Thông tin người dùng hiện tại
	 * @private
	 */
	_handleNewInvoiceNotifications(data, notificationMess, store, orgIdWorking, user) {
		const me = this;
		const { Type } = data;

		// Kiểm tra quyền truy cập đối với đơn vị của hóa đơn
		if (
			orgIdWorking === notificationMess.OrgId ||
			(orgIdWorking === notificationMess.OrganizationIdWorking &&
				me.checkAccessOrgByUser(notificationMess.OrgId, user))
		) {
			// Thêm thông báo vào chuông với hóa đơn đã kiểm tra
			// Chỉ thực hiện thêm với TH là kiểm tra lại
			if (Type == InvoiceChecked && notificationMess.IsCheckAgain) {
				store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
			}

			// Xử lý thông báo hóa đơn mới
			me.handlerNewInvoice(data, notificationMess);
		} else {
			// Kiểm tra nếu đơn vị thuộc cây tổ chức hiện tại
			const orgUnits = store.getters['organization/getAllTreeOrganizations'];
			if (orgUnits && orgUnits.length > 0) {
				const org = commonFunc.getOrgWorkingUpdate(orgUnits, { Id: notificationMess.OrgId });
				if (org) {
					store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
				}
			}
		}
	}

	/**
	 * Thêm thông báo vào quả chuông cho các trường hợp đặc biệt
	 * @param {Object} data - Dữ liệu từ server
	 * @param {Object} notificationMess - Đối tượng thông báo
	 * @param {Object} store - Vuex store
	 * @private
	 */
	_addSpecialNotificationsToBell(data, notificationMess, store) {
		const me = this;
		const { Type, Content } = data;

		// DQDUY 14.01.2025: Thông báo đặc biệt cần thêm vào quả chuông
		const isSpecialCase =
			(Type === ADD_INVOICE && !me.checkAutoDownload(Content.ExtraInfor)) ||
			(Type === FileHasProcessedDeclaration && !me.isNotSupport(Content.ExtraInfor)) ||
			(notificationMess.TypeReceive === MSEnum.TypeInvoiceReceive.Upload &&
				Type === FileHasProcessed &&
				data.IsOutbot) ||
			me.isSpecialInvoice(Content.ExtraInfor);

		if (isSpecialCase) {
			store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
		}
	}

	/**
	 * Xử lý thông báo từ email
	 * @param {Object} data - Dữ liệu từ server
	 * @param {Object} notificationMess - Đối tượng thông báo
	 * @param {Object} store - Vuex store
	 * @private
	 */
	_processEmailNotification(data, notificationMess, store) {
		const { Type, EmailId } = notificationMess;

		// Xử lý chỉ cho thông báo từ email
		if (
			EmailId &&
			(Type === ADD_EMAIL || Type === FileHasProcessed || Type === InvoiceChecked || Type === InvoiceNotFound)
		) {
			// Lắng nghe SignalR trả về hóa đơn đọc được từ email
			store.dispatch(`${ModuleInbox}/loadEmailByID`, EmailId).then(res => {
				if (res) {
					res = {
						...res,
						typePushEmail: data.Type,
						statusPushEmail: data.Status
					};
					store.commit(`${ModuleInbox}/updateEmail`, res);
					store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
				}
			});
		}
	}

	/**
	 * Kiểm tra user hiện tại có quyền làm việc với hóa đơn của đơn vị này hay không
	 * @param {string} orgId - ID của đơn vị chứa hóa đơn
	 * @param {Object} user - Thông tin người dùng
	 * @returns {boolean} - True nếu có quyền truy cập
	 */
	checkAccessOrgByUser(orgId, user) {
		const me = this;
		if (!orgId || !user) return false;
		if (user.Role == MSEnum.Role.Admin) return true;
		if (!user.AccessOnOrgs || user.AccessOnOrgs.length <= 0) return false;
		let org = user.AccessOnOrgs.find(x => x == orgId);
		if (org) return true;
		return false;
	}

	/**
	 * Thêm dữ liệu từ ExtraInfor vào đối tượng notification
	 * @param {Object} notificationMess - Đối tượng thông báo cần bổ sung thông tin
	 * @returns {Object} - Đối tượng thông báo đã được bổ sung thông tin
	 */
	addDataExtraInforToNotification(notificationMess) {
		let extraInfor = {};
		if (notificationMess && notificationMess.ExtraInfor) {
			extraInfor = JSON.parse(notificationMess.ExtraInfor);
			notificationMess = { ...notificationMess, ...extraInfor };
			notificationMess.extraInforObj = extraInfor;
		}
		return notificationMess;
	}

	/**
	 * Hiển thị popup hết hạn dùng sản phẩm
	 * @param {Date} expiredDate - Ngày hết hạn
	 */
	async handlerExprired(expiredDate) {
		const me = this;
		let instance = await PopupUtils.getPopupInstanceAsync('Expried');
		if (expiredDate != null) {
			instance.expired = expiredDate;
		}
		instance.showPopup();
	}

	/**
	 * Tăng số lượng hóa đơn đầu vào theo đơn vị
	 * @param {string} origanizationId - ID của đơn vị
	 */
	increaseInvoiceCount(origanizationId) {
		store.commit(`${ModuleOrganization}/increaseInvoiceCount`, origanizationId);
	}

	/**
	 * Tăng số lượng hóa đơn đầu ra theo đơn vị
	 * @param {string} origanizationId - ID của đơn vị
	 */
	increaseOutInvoiceCount(origanizationId) {
		store.commit(`${ModuleOrganization}/increaseOutInvoiceCount`, origanizationId);
	}

	/**
	 * Cập nhật tổng số email chưa đọc
	 */
	updateTotalEmailNoRead() {
		store.dispatch(`${ModuleInbox}/loadTotalEmailNoRead`);
	}

	/**
	 * Tăng số tờ khai theo chi nhánh
	 * @param {string} origanizationId - ID của đơn vị
	 */
	increaseDeclarationCount(origanizationId) {
		store.commit(`${ModuleOrganization}/increaseDeclarationCount`, origanizationId);
	}

	/**
	 * Xử lý khi có hóa đơn mới
	 * @param {Object} data - Dữ liệu từ server
	 * @param {Object} notificationMess - Đối tượng thông báo
	 */
	handlerNewInvoice(data, notificationMess) {
		const me = this;
		let content = data.Content;
		let isAutoDownload = me.checkAutoDownload(content.ExtraInfor);
		if (data.Type == FileHasProcessed && !me.checkFileProcessedStatusDuplicate(data)) {
			if (data.IsOutbot) {
				me.increaseOutInvoiceCount(data.Content.OriganizationId);
				if (notificationMess.TypeReceive == MSEnum.TypeInvoiceReceive.Upload) {
					//Nguồn upload hóa đơn
					EventBusGlobal.$emit(
						GlobalEventName.RefreshOutInvoice,
						{
							shimmerLoaded: true
						},
						true
					);
				}
			} else {
				me.increaseInvoiceCount(data.Content.OriganizationId);
				if (
					notificationMess.TypeReceive == MSEnum.TypeInvoiceReceive.Upload ||
					me.isSpecialInvoice(data.Content.ExtraInfor)
				) {
					//Nguồn upload hóa đơn
					EventBusGlobal.$emit(GlobalEventName.RefreshInvoicesFirstPage, {
						shimmerLoaded: true,
						isGetTotal: true,
						isDelay: true
					});
				}
			}
		} else if (data.Type == FileHasProcessedDeclaration && !me.checkFileProcessedStatusDuplicate(data)) {
			if (data.Content.OriganizationId) {
				me.increaseDeclarationCount(data.Content.OriganizationId);
			}
			EventBusGlobal.$emit(GlobalEventName.RefreshDeclaration, {
				shimmerLoaded: true
			});
		} else if (data.Type == InvoiceChecked && !isAutoDownload && !data.Content.EmailStatus) {
			//Trong tất cả các trường hợp thì đều có bắn thông báo type là InvoiceChecked
			//Sẽ case khi có EmailStatus thì không gọi reload
			EventBusGlobal.$emit(GlobalEventName.RefreshInvoicesFirstPage, {
				shimmerLoaded: true,
				isDelay: true
			});
		} else if (data.Type == ADD_INVOICE) {
			store.commit(`${ModuleOrganization}/updateTourGuide`);
			let invoiceCreator = me.checkInvoiceCreatorByExtraInfo(notificationMess.ExtraInfor);
			if (data.IsOutbot) {
				//Với hóa đơn tải từ nguồn CQT/kết nối NCC
				if (invoiceCreator == MSEnum.InvoiceCreatorFlags.AutoRead) {
					me.increaseOutInvoiceCount(data.Content.OriganizationId);
				}
				//Đã tăng số lượng ở push FileHasProcessed (xử lý thêm file, dữ liệu hóa đơn thành công)
				//Đã thực hiện cộng rồi không cần cộng nữa
				// me.increaseOutInvoiceCount(data.Content.OriganizationId);
			} else {
				//Với hóa đơn tải từ nguồn CQT/kết nối NCC
				if (invoiceCreator == MSEnum.InvoiceCreatorFlags.AutoRead) {
					me.increaseInvoiceCount(data.Content.OriganizationId);
				}
				//Đã tăng số lượng ở push FileHasProcessed (xử lý thêm file, dữ liệu hóa đơn thành công)
				//Đã thực hiện cộng rồi không cần cộng nữa
				// me.increaseInvoiceCount(data.Content.OriganizationId);
				// EventBusGlobal.$emit(GlobalEventName.RefreshInvoicesFirstPage, {
				// 	shimmerLoaded: true
				// });
			}
			EventBusGlobal.$emit(GlobalEventName.ReloadOrg);
		}

		if (content.EmailId) {
			store.dispatch(`${ModuleInbox}/loadEmailByID`, content.EmailId).then(res => {
				if (res) {
					res = { ...res, typePushEmail: data.Type, statusPushEmail: data.Status };
					store.commit(`${ModuleInbox}/updateEmail`, res);
					//K thêm thông báo 2 lần cần chặn thêm ở  => k phải luồng kiểm tra lại hóa đơn thì mới được add
					// Tránh add trùng: case InvoiceChecked + IsCheckAgain đã add ở _handleNewInvoiceNotifications
					if (!(data.Type == InvoiceChecked && notificationMess.IsCheckAgain)) {
						store.commit(`${ModuleNotification}/addNewNotification`, notificationMess);
					}
				}
			});
		}
	}

	/**
	 * Kiểm tra thông tin invoice creator từ ExtraInfo
	 * @param {string} extraInfo - Chuỗi JSON thông tin bổ sung
	 * @returns {number} - Loại invoice creator
	 */
	checkInvoiceCreatorByExtraInfo(extraInfo) {
		if (!extraInfo) return null;
		extraInfo = JSON.parse(extraInfo);
		if (!extraInfo) return null;
		return extraInfo.InvoiceCreator;
	}

	/**
	 * Lấy thông tin nguồn nhận file
	 * @author dqduy 14.01.2025
	 * @param {string} extraInfo - Chuỗi JSON thông tin bổ sung
	 * @returns {number} - Loại nguồn nhận
	 */
	getTypeReceive(extraInfo) {
		if (!extraInfo) return null;
		extraInfo = JSON.parse(extraInfo);
		if (!extraInfo) return null;
		return extraInfo.TypeReceive;
	}

	/**
	 * Kiểm tra có phải hóa đơn đặc biệt không
	 * @param {string} extraInfo - Chuỗi JSON thông tin bổ sung
	 * @returns {boolean} - True nếu là hóa đơn đặc biệt
	 */
	isSpecialInvoice(extraInfo) {
		if (!extraInfo) return null;
		extraInfo = JSON.parse(extraInfo);
		if (!extraInfo) return null;
		return extraInfo.IsSpecialInvoice;
	}

	/**
	 * Kiểm tra có phải loại không được hỗ trợ không
	 * @param {string} extraInfo - Chuỗi JSON thông tin bổ sung
	 * @returns {boolean} - True nếu không được hỗ trợ
	 */
	isNotSupport(extraInfo) {
		if (!extraInfo) return null;
		extraInfo = JSON.parse(extraInfo);
		if (!extraInfo) return null;
		return extraInfo.IsNotSupport;
	}

	/**
	 * Kiểm tra tự động tải xuống
	 * @param {string} extraInfo - Chuỗi JSON thông tin bổ sung
	 * @returns {boolean} - True nếu tự động tải xuống
	 */
	checkAutoDownload(extraInfo) {
		if (!extraInfo) return null;
		extraInfo = JSON.parse(extraInfo);
		if (!extraInfo) return null;
		return extraInfo.AutoReceive;
	}

	/**
	 * Kiểm tra trạng thái trùng lặp của file đã xử lý
	 * @param {Object} data - Dữ liệu từ server
	 * @returns {boolean} - True nếu có trùng lặp
	 */
	checkFileProcessedStatusDuplicate(data) {
		if (
			!data ||
			!data.Content ||
			!data.Content.FileProcessedStatus ||
			!data.Content.FileProcessedStatus.Candidates ||
			data.Content.FileProcessedStatus.Candidates.length <= 0
		) {
			return false;
		}

		let candidateDuplicates = data.Content.FileProcessedStatus.Candidates.filter(x => x.OrgIdInvDuplicate);
		return (
			candidateDuplicates &&
			candidateDuplicates.length > 0 &&
			candidateDuplicates.length &&
			data.Content.FileProcessedStatus.Candidates.length
		);
	}

	/**
	 * Kết nối tới máy chủ SignalR
	 * @param {Object} store - Vuex store
	 */
	startConnection(store) {
		const me = this;
		if (!me.isConnected) {
			//Connect tới máy chủ SignalR
			me.connection
				.start()
				.then(() => {
					console.log('Kết nối thành công SignalR, url:: ' + apiConfig['SignalR']);
					me.isConnected = true;
					//Đăng ký MST vào SignalR
					if (store.getters['organization/getSubscriberWorking'].Id) {
						me.registerGroup(store.getters['organization/getSubscriberWorking'].Id);
					}
				})
				.catch(ex => {
					me.isConnected = false;
					console.log('Lỗi kết nối tới SignalR:: ', ex);
					//Kết nối lại sau một khoảng thời gian tới máy chủa SignalR
					me.reConnection(store);
				});
		}
	}

	/**
	 * Kết nối lại tới máy chủ SignalR
	 * @param {Object} store - Vuex store
	 */
	reConnection(store) {
		const me = this;
		setTimeout(() => {
			console.log('Kết nối lại sau 5s tới máy chủ SignalR');
			me.startConnection(store);
		}, 5 * 1000);
	}

	/**
	 * Ngừng kết nối tới máy chủ SignalR
	 */
	stopConnection() {
		const me = this;
		if (me.isConnected) {
			me.connection
				.stop()
				.then(() => {
					me.isConnected = false;
					console.log('Ngắt kết nối thành công tới SignalR');
				})
				.catch(ex => {
					me.isConnected = false;
					console.log('Lỗi ngắt kết nối tới SignalR:: ', ex);
				});
		}
	}

	/**
	 * Hàm này dùng để thêm MST vào group
	 * @param {string} groupName - Tên group (thường là MST)
	 */
	registerGroup(groupName) {
		const me = this;
		if (me.isConnected) {
			me.connection.invoke('register', groupName);
		}
	}

	/**
	 * Hàm này dùng để xóa MST khỏi group
	 * @param {string} groupName - Tên group (thường là MST)
	 */
	removeGroup(groupName) {
		const me = this;
		if (me.isConnected) {
			me.connection.invoke('remove', groupName);
		}
	}

	/**
	 * Hàm này dùng để gửi tin nhắn
	 * @param {string} groupName - Tên group (thường là MST)
	 * @param {string} message - Nội dung tin nhắn
	 */
	sentMessage(groupName, message) {
		const me = this;
		if (me.isConnected) {
			me.connection.invoke('SendMessage', groupName, message);
		}
	}

	/**
	 * Lấy icon thông báo dựa vào loại thông báo
	 * @param {Object} item - Đối tượng thông báo
	 * @returns {string} - Tên class icon
	 */
	getIconNotification(item) {
		let icon = 'mi-notification-common';
		let type = item.type;
		switch (type) {
			case ADD_INVOICE:
				//Vừa kiểm tra xong hóa đơn {0}.
				if (item.Status == 'Updated') {
					icon = 'mi-notification-file-checked';
				} else if (item.Status == 'Deleted') {
					//Hóa đơn bị xóa bỏ: {0}
					icon = 'mi-notification-file-delete';
				}
				break;
			case ADD_EMAIL:
				//Vừa nhận được email không phải là email hóa đơn đến {0}.
				if (item.Status == 'New') {
					//Vừa nhận được email gửi đến {0}
					icon = 'mi-notification-email';
				}
				break;
			case UPDATE_NOTIFICATION:
				icon = 'mi-notification-supplier-success';
				break;
			case EXPIRED:
				//Hiện tại chưa dùng
				break;
			case FileHasProcessed:
				//Đã xử lý xong tệp
				icon = 'mi-notification-file-checked';
				break;
			case FileHasProcessedDeclaration:
				//Đã xử lý xong tệp
				icon = 'mi-notification-file-checked';
				break;
			case FileFailedProcessed:
				//Xử lý tệp thất bại
				icon = 'mi-notification-file-warning';
				break;
			case FileFailedProcessedDeclaration:
				//Xử lý tệp thất bại
				icon = 'mi-notification-file-warning';
				break;
			case InvoiceChecked:
				//Thông báo đã kiểm tra xong hóa đơn
				icon = 'mi-notification-file-checked';
				break;
			case NotifyProcessCheckSupplier:
				icon = 'mi-notification-supplier-success';
				break;
			case NotifySync:
				//Hoàn tất quá trình đồng bộ dữ liệu của NCC
				icon = 'mi-notification-supplier';
				break;
			case NotifySyncTaxaxion:
				//Hoàn tất quá trình đồng bộ dữ liệu của CQT
				icon = 'mi-notification-tax';
				break;
			case LoadAgainPdfFromEmail:
				//Kiểm tra tải lại PDF từ email
				icon = 'mi-notification-download-pdf-email';
				break;
			case DownAgainPdfSuccess:
				//Kiểm tra tải lại PDF từ email
				icon = 'mi-notification-download-pdf-email';
				break;
			case DownAgainPdfFail:
				//Kiểm tra tải lại PDF từ email
				icon = 'mi-notification-download-pdf-email';
				break;
			case AutoDownload:
				if (item.TotalDownloadSuccess > 0 && item.TotalDownloadFail > 0) {
					icon = 'mi-notification-download';
				} else if (item.TotalDownloadSuccess > 0) {
					icon = 'mi-notification-download-success';
				} else if (item.TotalDownloadFail > 0) {
					icon = 'mi-notification-download-fail';
				}
				break;
		}
		return icon;
	}

	/**
	 * Hiển thị popup cảnh báo khi hóa đơn trùng trong quá trình điều chuyển từ queue
	 * @param {Object} notificationMess - Thông báo notification
	 * @param {Object} extraInforObj - Thông tin bổ sung đã parse
	 */
	showMoveInvoiceDuplicatePopup(notificationMess, extraInforObj) {
		const me = this;
		EventBusGlobal.$emit(GlobalEventName.MoveInvoiceDuplicate, extraInforObj);
	}

	/**
	 * Hiển thị popup cảnh báo khi tờ khai trùng trong quá trình điều chuyển từ queue
	 * @param {Object} notificationMess - Thông báo notification
	 * @param {Object} extraInforObj - Thông tin bổ sung đã parse
	 */
	showMoveDeclarationDuplicatePopup(notificationMess, extraInforObj) {
		const me = this;

		// Emit đầy đủ payload để màn Navbar có thể ưu tiên hiển thị đúng ngôn ngữ.
		// - extraInforObj: dữ liệu parse từ ExtraInfor (thường có IsDuplicate + các thông tin liên quan)
		// - notificationMess: object notification đã build (có thể có TitleEnglish/ContentEnglish tùy BE)
		EventBusGlobal.$emit(GlobalEventName.MoveDeclarationDuplicate, {
			extraInforObj,
			notificationMess
		});
	}

	/**
	 * Xử lý các thông báo đồng bộ dữ liệu CQT
	 * @param {Object} notification - Thông báo từ server
	 */
	processSyncDataTax(notification) {
		const me = this;
		let notificationType = notification.Type;
		let notifications = store.getters['notificationuser/GetNotificationProcessSyncData'];
		if (!notifications) notifications = [];

		//console.log(notifications, "notifications");
		//Lấy thông báo đang có ở trên trong store
		let index = notifications.findIndex(x => {
			return x.SyncTimeId == notification.SyncTimeId;
		});

		if (index >= 0 && notifications[index].AmountMaster > 0) {
			let notifiStore = notifications[index];
			//Số lượng inbot, outbot
			let numberInOut = 0;
			if (notifiStore.IsInbot) numberInOut += 1;
			if (notifiStore.IsOutbot) numberInOut += 1;
			if (notifiStore.IsSyncOne) numberInOut = 1;
			if (numberInOut > 0) {
				if (notificationType == GetInvoicesTax) {
					if (notification.InvDownloadNumber == 0) {
						// Xử lý xong master
						notifiStore.Percentage += 100 / notifiStore.AmountMaster / numberInOut;
						if (!notifiStore.Masters) notifiStore.Masters = [];
						let checkMaster = notifiStore.Masters.findIndex(x => {
							return x.ConnectInvoiceMasterId == notification.ConnectInvoiceMasterId;
						});
						if (checkMaster >= 0) {
							//TODO:
						} else {
							let master = {
								ConnectInvoiceMasterId: notification.ConnectInvoiceMasterId,
								InvDownloadNumber: notification.InvDownloadNumber
							};
							notifiStore.Masters.push(master);
						}
					} else {
						if (!notifiStore.Masters) notifiStore.Masters = [];
						let checkMaster = notifiStore.Masters.findIndex(x => {
							return x.ConnectInvoiceMasterId == notification.ConnectInvoiceMasterId;
						});
						if (checkMaster >= 0) {
							//TODO:
						} else {
							let master = {
								ConnectInvoiceMasterId: notification.ConnectInvoiceMasterId,
								InvDownloadNumber: notification.InvDownloadNumber
							};
							notifiStore.Masters.push(master);
						}
					}
				} else if (notificationType == ProcessingInvoiceTax) {
					if (!notifiStore.Masters) notifiStore.Masters = [];
					let indexMaster = notifiStore.Masters.findIndex(x => {
						return x.ConnectInvoiceMasterId == notification.ConnectInvoiceMasterId;
					});
					if (indexMaster >= 0) {
						if (!notifiStore.Masters[indexMaster].Details) notifiStore.Masters[indexMaster].Details = [];
						var filterDetail = notifiStore.Masters[indexMaster].Details.filter(
							x => x.ConnectInvoiceDetailId == notification.ConnectInvoiceDetailId
						);
						// console.log(filterDetail, "filterDetail");
						if (
							notifiStore.Masters[indexMaster].Details &&
							notifiStore.Masters[indexMaster].Details.length <= 0
						) {
							// console.log(notifiStore.Percentage, "Prev");
							notifiStore.Percentage += 100 / notifiStore.AmountMaster / numberInOut;
							// console.log(notifiStore.Percentage, "Next");
						}
						if (!filterDetail || filterDetail.length <= 0) {
							let detail = {
								ConnectInvoiceDetailId: notification.ConnectInvoiceDetailId,
								ConnectInvoiceStatus: notification.ConnectInvoiceStatus,
								ConnectInvoiceMasterId: notification.ConnectInvoiceMasterId
							};
							notifiStore.Masters[indexMaster].Details.push(detail);
						}
					}
				} else if (notificationType == EndProcessingInvoiceTax) {
					if (!notifiStore.Masters) notifiStore.Masters = [];
					let checkMaster = notifiStore.Masters.findIndex(x => {
						return x.ConnectInvoiceMasterId == notification.ConnectInvoiceMasterId;
					});
					if (checkMaster >= 0) {
						//TODO:
					} else {
						let master = {
							ConnectInvoiceMasterId: notification.ConnectInvoiceMasterId,
							InvDownloadNumber: notification.InvDownloadNumber
						};
						// console.log(master, "master");
						notifiStore.Masters.push(master);
					}
					// console.log(notifiStore.Percentage, "Prev");
					notifiStore.Percentage += 100 / notifiStore.AmountMaster / numberInOut;
					// console.log(notifiStore.Percentage, "Next");
				}
				if (notifiStore.Percentage >= 100) notifiStore.Percentage = 100;
				if (notifiStore.Masters) {
					notifications[index].Masters = notifiStore.Masters;
				}
				notifications[index].Percentage = notifiStore.Percentage;
				// console.log(notifiStore, "notifiStore");
				// let payloadUpdate = {
				// 	index: index,
				// 	data: notifications[index]
				// };
				//Cập nhật lại thông báo trong store
				store.commit(`${ModuleNotificationUser}/updateNotificationProcessSyncData`, notifications);
			}
		}
	}
}

export default new PushHandler();
